import {
  Grid,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper
} from '@material-ui/core';
import React, { Component } from 'react';
import { apiBatchRequest, downloadReport } from '../../utils/api_service';
import { API_URL } from '../../constants/api';
import commonLabels from '../../constants/messageConstants';
import { ShowToast, toastType } from '../../utils/toast-service';
import Reports from './Reports';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';
import './report.less';
import DateFnsUtils from '@date-io/date-fns';
import { DateFormat } from '../../constants/appConstants';
import moment from 'moment';
import PageHeader from '../common/PageHeader';
import Autocomplete from '@material-ui/lab/Autocomplete';
import _ from 'lodash';
import ReportButtons from './ReportButtons';
import AdvancedFilter from './AdvancedFilter';
import { GenerateAbsoluteURL, removeDuplicates, disableDatesForPayCycleStart1, disableDatesForPayCycleEnd1, EnhancedTableHead, orderBy, getPreviousPayCycle, IsAutoRunPagesEnabled } from '../../utils/helper';
import { getMultilevelGroupedData } from '../../utils/generic';
import { getFormattedValues } from '../../utils/formatData';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import PageLandingMessage from '../common/PageLandingMessage/PageLandingMessage'

const changeInAllocationEmployeeByMarket = [
  { key: 'effectiveAllocationStartDate', dataFormat: 'Text', display: 'Effective Allocation Start Date' },
  { key: 'effectiveAllocationEndDate', dataFormat: 'Text', display: 'Effective Allocation End Date' },
  { key: 'allocationPercent', dataFormat: 'TextNew', display: 'Allocation Percent' }];
const headCells = [
  {
    id: 'email',
    numeric: false,
    disablePadding: true,
    label: 'Email',
    type: 'Text'
  },
  {
    id: 'effectiveAllocationStartDate',
    numeric: false,
    disablePadding: true,
    label: 'Allocation Start Date',
    type: 'Text'
  },
  {
    id: 'effectiveAllocationEndDate',
    numeric: false,
    disablePadding: true,
    label: 'Allocation End Date',
    type: 'Text'
  },
  {
    id: 'allocationPercent',
    numeric: false,
    disablePadding: true,
    label: 'Allocation Percent',
    type: 'Number',
    isSort: false
  }
];
let temcurrentGroupedRow = [];
export default class ChangeInAllocationEmployeeByMarket extends Component {
  // Constructor to initialize state
  constructor(props) {
    super(props);
    this.state = {
      showMain: false,
      employeeData: [],
      employeeSummary: [],
      startDate: getPreviousPayCycle().previousPayCycleStartDate,
      endDate: getPreviousPayCycle().previousPayCycleEndDate,
      maxEndDate: getPreviousPayCycle().previousPayCycleEndDate,
      showReport: false,
      marketMasterData: [],
      divisionMasterData: [],
      departmentMasterData: [],
      // department: [{department: 'All'}],
      division: [{ division: 'All' }],
      market: [{ marketName: 'All' }],
      designation: [{ designation: 'All' }],
      department: [{ departmentName: 'All' }],
      employee: [{ employeeName: 'All' }],
      SupervisorEmployee: [{ employeeName: 'All' }],
      supervisorEmployeeMasterData: [],
      openSlidingPanel: false,
      isAutoRunEnabled: IsAutoRunPagesEnabled(),
      isSubmitButtonClicked: false,
      advanceFilterConfig: {
        groupBy: {
          masterData: [
            {
              key: 'Market',
              value: 'market',
              id: 'market',
              ssrsReport: 'Market',
              numeric: false,
              disablePadding: false,
              label: 'Market',
              type: 'Text',
              order: 1
            },
            {
              key: 'Department',
              value: 'department',
              id: 'department',
              ssrsReport: 'Department',
              numeric: false,
              disablePadding: false,
              label: 'Department',
              type: 'Text',
              order: 3
            },
            {
              key: 'Division',
              id: 'division',
              value: 'division',
              ssrsReport: 'Division',
              numeric: false,
              disablePadding: false,
              label: 'Division',
              type: 'Text',
              order: 4
            }],
          selected: [{
            key: 'Employee',
            value: 'employee',
            id: 'employee',
            ssrsReport: 'Employee',
            numeric: false,
            disablePadding: false,
            label: 'Employee',
            type: 'Text',
            order: 2
          }]
        },
        selectedDate: {},
        suppressGraph: false,
        suppressZero: false,
        summaryRows: false,
        showZeroNGraph: false,
        startDate: getPreviousPayCycle().previousPayCycleStartDate,
        endDate: getPreviousPayCycle().previousPayCycleEndDate,
        RadioSelect: 'CDR',
        order: 'asc',
        orderBy: 'nam'
      },
      printPage: false,
      employeeMasterData: []
    };

    this.baseState = this.state;
  }

  // Method to get data before components are mounted
  componentDidMount() {
    this.GetMasterData();
  }

  // Get Master data using API calls to fill filters
  GetMasterData = () => {
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Market.GetMarketMasterdata,
        key: 'marketMasterData',
        fromCache: true,
        duration: 15
      },
      {
        url: API_URL.Employee.GetEmployeeMasterData + '?showInActive=true',
        key: 'employeeMasterData'
      },
      {
        url: API_URL.Employee.GetDepartmentMasterData,
        key: 'departmentMasterData',
        fromCache: true,
        duration: 15
      },
      {
        url: API_URL.Allocation.GetDivisions,
        key: 'divisionMasterData'
      }
    ])
      .then(({ marketMasterData, employeeMasterData, departmentMasterData, divisionMasterData }) => {
        this._asyncRequest = null;
        if (marketMasterData.success !== true) {
          ShowToast(
            commonLabels.somethingWrong,
            toastType.ERROR,
            5000,
            500,
            'Server error'
          );
        }
        this.setState({
          marketMasterData: marketMasterData.data,
          employeeMasterData: employeeMasterData.data,
          departmentMasterData: departmentMasterData.data,
          divisionMasterData: divisionMasterData.data,
          supervisorEmployeeMasterData: employeeMasterData.data || []
        }, () => {
          if(this.state.isAutoRunEnabled || this.state.isSubmitButtonClicked){
            this.handleSubmit();
          }          
        });
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  };

  // Go to report's list
  goBack = () => {
    this.setState({
      showMain: true
    });
  };

  // Date change event of calendar
  handleDateChange = (date, name) => {
    const { advanceFilterConfig } = this.state;
    localStorage.setItem('DateRadioSelect', 'CDR');
    const formattedDate = moment(date).format(DateFormat);
    if (name === 'startDate') {
      advanceFilterConfig.startDate = formattedDate;
      localStorage.setItem('selectedstartDate', formattedDate);
      this.setState({
        [name]: formattedDate
      });
    } else {
      advanceFilterConfig.endDate = formattedDate;
      localStorage.setItem('selectedendDate', formattedDate);
      this.setState({
        [name]: formattedDate
      });
    }
  };

  // Get Report Data based on selected filters
  GetChangeInMarketAllocation = () => {
    const { startDate, endDate, market, employee, division, department, SupervisorEmployee } = this.state;
    const marketId = _.cloneDeep(market.map((x) => x.marketId));
    const employeeId = _.cloneDeep(employee.map((x) => x.employeeId));
    const departmentId = _.cloneDeep(department.map((x) => x.departmentId));
    const divisionId = _.cloneDeep(division.map((x) => x.divisionId));
    const supervisorId = _.cloneDeep(SupervisorEmployee.map((x) => x.ultiProEmployeeId));

    const params = {
      startDate: moment(startDate).format(DateFormat),
      endDate: moment(endDate).format(DateFormat),
      marketId: marketId.join('|'),
      employeeId: employeeId.join('|'),
      departmentId: departmentId.join('|'),
      divisionId: divisionId.join('|'),
      supervisorId: supervisorId.join('|')
    };
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Report.GetChangeInMarketAllocation,
        params,
        key: 'employeeData'
      }
    ])
      .then(({ employeeData }) => {
        this._asyncRequest = null;
        if (employeeData.success !== true) {
          ShowToast(
            commonLabels.somethingWrong,
            toastType.ERROR,
            5000,
            500,
            'Server error'
          );
        }
        this.setState({
          employeeData: employeeData.data,
          employeeSummary: employeeData.config,
          showReport: true,
          isSubmitButtonClicked: true
        });
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  };

  // Reset filters and load report data
  resetPage = () => {    
    const { advanceFilterConfig } = this.state;    
    advanceFilterConfig.groupBy = {
      masterData: [
        {
          key: 'Market',
          value: 'market',
          id: 'market',
          ssrsReport: 'Market',
          numeric: false,
          disablePadding: false,
          label: 'Market',
          type: 'Text',
          order: 1
        },
        {
          key: 'Department',
          value: 'department',
          id: 'department',
          ssrsReport: 'Department',
          numeric: false,
          disablePadding: false,
          label: 'Department',
          type: 'Text',
          order: 3
        },
        {
          key: 'Division',
          id: 'division',
          value: 'division',
          ssrsReport: 'Division',
          numeric: false,
          disablePadding: false,
          label: 'Division',
          type: 'Text',
          order: 4
        }],
      selected: [{
        key: 'Employee',
        value: 'employee',
        id: 'employee',
        ssrsReport: 'Employee',
        numeric: false,
        disablePadding: false,
        label: 'Employee',
        type: 'Text',
        order: 2
      }]
    };
    this.setState({
      ...this.baseState,
      isSubmitButtonClicked: false,
      advanceFilterConfig
    });
    this.componentDidMount();
  };

  // Disable other dates  except pay cycle start dates (i.e. Excluding 1 & 16) on Pay Cycle Start calendar 
  disableDatesForPayCycleStart = (date) => {
    return disableDatesForPayCycleStart1(date);
  }

  // Disable other date except pay cycle end dates (i.e. excluding mid and last day of the month) on Pay Cycle End calendar
  disableDatesForPayCycleEnd = (date) => {
    return disableDatesForPayCycleEnd1(date);
  }

  // Handle sorting on table columns
  handleRequestSort = (event, property) => {
    const isAsc = this.state.orderBy === property && this.state.order === 'asc';
    this.setState({
      order: isAsc ? 'desc' : 'asc',
      orderBy: property
    });
  };

  // Render report data into Table format
  renderTable = (employeeData) => {
    const groupSequence = this.getColumnSequence();
    return (
      <Table className="reportTable" id="rptTable" stickyHeader>
        <EnhancedTableHead
          order={this.state.order}
          orderBy={this.state.orderBy}
          onRequestSort={this.handleRequestSort}
          rowCount={employeeData.length}
          columnSequence={groupSequence}
          headCells={headCells}
        />
        <TableBody> {this.renderTableRow(
          orderBy(employeeData, this.state.orderBy, this.state.order)
        )}</TableBody>
      </Table>
    );
  };

  // Render record wise table row
  renderTableRow = (data) => {
    if (this.state.advanceFilterConfig.suppressZero === true) {
      data = data.filter(x => {
        return _.chain(x.reimbursmentDetails).sumBy(x => x.reimbursementCost).value() !== 0;
      });
    }
    const selectedGroupLength = this.state.advanceFilterConfig.groupBy.selected.length;
    if (selectedGroupLength > 0) {
      temcurrentGroupedRow = [];
      return this.renderTableCell(
        getMultilevelGroupedData(
          data,
          this.state.advanceFilterConfig.groupBy.selected.map((x) => x.value)
        ),
        []
      );
    } else {
      temcurrentGroupedRow = [];
      return this.renderTableCell(
        getMultilevelGroupedData(
          data,
          []
        ),
        []
      );
    }
  };

  // Render table cell with formatted values
  renderTableCell = (groupedData, currentGroupedRow = [], tableCell = [], rowCount = 0) => {
    const sequence = this.getColumnSequence();

    groupedData.forEach((d, i) => {
      let column1 = (temcurrentGroupedRow.find(x => x.key === sequence[0].value) || {})?.value || null;
      let column2 = (temcurrentGroupedRow.find(x => x.key === sequence[1].value) || {})?.value || null;
      let column3 = (temcurrentGroupedRow.find(x => x.key === sequence[2].value) || {})?.value || null;
      let column4 = (temcurrentGroupedRow.find(x => x.key === sequence[3].value) || {})?.value || null;

      if (d.data !== undefined) {
        this.renderTableCell(d.data, currentGroupedRow, tableCell, rowCount);
      } else {
        const groupColumns = this.state.advanceFilterConfig.groupBy.selected;

        groupColumns?.forEach(g => {
          temcurrentGroupedRow = temcurrentGroupedRow.filter((x) => x.key !== g.value);

          temcurrentGroupedRow.push({ key: g.value, value: d[g.value] });
        });
      }
      const keyvalue = this.adjustColumnSequence(_.cloneDeep(temcurrentGroupedRow));
      const evenOddClass =
        tableCell.length % 2 === 0 ? ' rpt rpt-even ' : ' rpt rpt-odd ';
      const topBorderClass =
        column1 !== (keyvalue.find(x => x.key === sequence[0].value) || {}).value ?? '' ? ' rpt-topBorder ' : ' ';
      const key = d.market + '_' + d.employeeId + '_' + rowCount + '_' + i;
      if (d.data === undefined) {
        tableCell.push(
          <TableRow key={key} className={topBorderClass}>
            <TableCell className={evenOddClass + topBorderClass}>
              {getFormattedValues(column1 !== d[sequence[0].value] && d[sequence[0].value], 'Text')}{' '}

            </TableCell>
            <TableCell className={evenOddClass + topBorderClass}>
              {getFormattedValues((column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value]) && d[sequence[1].value], 'Text')}{' '}
            </TableCell>
            <TableCell className={evenOddClass + topBorderClass}>
              {getFormattedValues((column3 !== d[sequence[2].value] || column2 !== d[sequence[1].value]) && d[sequence[2].value], 'Text')}{' '}
            </TableCell>
            <TableCell className={evenOddClass + topBorderClass}>
              {getFormattedValues((column4 !== d[sequence[3].value] || column3 !== d[sequence[3].value]) && d[sequence[3].value], 'Text')}{' '}
            </TableCell>
            <TableCell className={evenOddClass + 'rpt-topBorder'}>
              {getFormattedValues(d.email, 'Text')}{' '}
            </TableCell>
            {changeInAllocationEmployeeByMarket.map((element, ind) =>
            (
              <TableCell key={key + ind} className={evenOddClass + 'rpt-topBorder'}>
                {getFormattedValues(d[element.key], element.dataFormat)}{' '}
              </TableCell>
            ))}
          </TableRow>
        );
      }
      rowCount++;
      column1 = (temcurrentGroupedRow.find((x) => x.key === sequence[0].value) || {}).value ?? null;
      column2 = (temcurrentGroupedRow.find((x) => x.key === sequence[1].value) || {}).value ?? null;
      column3 = (temcurrentGroupedRow.find((x) => x.key === sequence[2].value) || {}).value ?? null;
      column4 = (temcurrentGroupedRow.find((x) => x.key === sequence[3].value) || {}).value ?? null;
    });
    return tableCell;
  }

  // Handle click event of Run Report button
  handleSubmit = () => {    
    this.GetChangeInMarketAllocation();
  };

  // Open sliding panel
  handleClickOpen = () => {    
    this.setState({
      openSlidingPanel: true
    });
  };

  // Method to print report
  handlePrintClick = () => {
    this.setState(
      {
        printPage: true
      },
      window.print()
    );
  };

  // Handle change event of filters/grouping in Advanced filters
  onAddvanceFilterChange = (advanceFilterConfig) => {    
    this.setState({
      advanceFilterConfig: advanceFilterConfig,
      openSlidingPanel: false      
    }, () => this.GetChangeInMarketAllocation());
  }

  // Get table column sequence based on grouping selected in Advanced filter
  getColumnSequence = () => {
    if (this.state.advanceFilterConfig.groupBy.selected.length === 0) {
      return removeDuplicates(
        [          
          ...this.state.advanceFilterConfig.groupBy.masterData
        ],
        'key'
      );
    } else {
      return removeDuplicates(
        [
          ...this.state.advanceFilterConfig.groupBy.selected,
          ...this.state.advanceFilterConfig.groupBy.masterData
        ],
        'key'
      );
    }
  };

  // Adjust column sequence based on grouping selected
  adjustColumnSequence = (currentGroupedRow) => {
    this.state.advanceFilterConfig.groupBy.masterData.forEach(x => {
      currentGroupedRow.push({ key: x.value });
    }
    );
    return currentGroupedRow;
  }

  // Close sliding panel
  handleClose = () => {
    this.setState({
      openSlidingPanel: false
    });
  };

  // Handle change event of filter values
  handleChange = (_e, value, name, optionLabel) => {
    if ((this.state[name] || []).find(x => x[optionLabel] === 'All') === undefined) {
      if (value && value.length === 0) {
        value = [{ [optionLabel]: 'All' }];
        this.setState({ [name]: value });
      } else if ((value || []).find(x => x[optionLabel] === 'All')) {
        this.setState({ [name]: [{ [optionLabel]: 'All' }] });
      } else {
        this.setState({ [name]: value });
      }
    } else {
      value = (value || []).filter(x => x[optionLabel] !== 'All');
      if (value && value.length === 0) {
        value = [{ [optionLabel]: 'All' }];
      }
      this.setState({ [name]: value });
    }
  };

  // Download report into excel or pdf file format
  downloadFile = (fileMimeType, type, isPrint) => {
    const { market, employee, advanceFilterConfig, startDate, endDate, division, department, SupervisorEmployee } = this.state;
    const dataValue = [
      { key: 'StartDate', value: moment(startDate).format(DateFormat) },
      { key: 'EndDate', value: moment(endDate).format(DateFormat) }
    ];
    const marketId = _.cloneDeep(market.map((x) => x.marketId));
    const supervisorId = _.cloneDeep(SupervisorEmployee.map((x) => x.ultiProEmployeeId));

    dataValue.push({ key: 'MarketId', value: (marketId.join('|') === undefined || marketId.join('|') === '') ? '0' : marketId.join('|') });
    const employeeId = _.cloneDeep(employee.map((x) => x.employeeId))
    dataValue.push({ key: 'EmployeeId', value: (employeeId.join('|') === undefined || employeeId.join('|') === '') ? '0' : employeeId.join('|') });
    const divisionId = _.cloneDeep(division.map((x) => x.divisionId));
    dataValue.push({ key: 'DivisionId', value: (divisionId.join('|') === undefined || divisionId.join('|') === '') ? '0' : divisionId.join('|') });
    const departmentId = _.cloneDeep(department.map((x) => x.departmentId));
    dataValue.push({ key: 'DepartmentId', value: (departmentId.join('|') === undefined || departmentId.join('|') === '') ? '0' : departmentId.join('|') });
    dataValue.push({ key: 'supervisorId', value: (supervisorId.join('|') === undefined || supervisorId.join('|') === '') ? '0' : supervisorId.join('|') });

    const url = GenerateAbsoluteURL(dataValue, advanceFilterConfig.groupBy.selected, 'Employee%20Allocation%20Change%20by%20Market%20Report', type);
    downloadReport(
      url,
      'Employee Allocation Activity By Market Report',
      fileMimeType,
      type,
      isPrint
    );
  }

  // Render method to render components based on conditions
  render() {
    const {
      showMain,
      employeeData,
      startDate,
      endDate,
      marketMasterData,
      showReport,
      employeeMasterData,
      advanceFilterConfig,
      openSlidingPanel,
      maxEndDate,
      divisionMasterData,
      departmentMasterData,
      supervisorEmployeeMasterData
    } = this.state;

    if (marketMasterData.find(x => x.marketName === 'All') === undefined) {
      marketMasterData.unshift({ marketName: 'All' });
    }
    if (employeeMasterData.find(x => x.employeeName === 'All') === undefined) {
      employeeMasterData.unshift({ employeeName: 'All' });
    }

    if (supervisorEmployeeMasterData.find(x => x.employeeName === 'All') === undefined) {
      supervisorEmployeeMasterData.unshift({ employeeName: 'All' });
    }

    return (
      <div>
        {showMain
          ? (
            <Reports />
          )
          : (
            <>
              <PageHeader
                key={'Change_in_Employee_Allocation_By_Market_Report'}
                title={'Employee Allocation Activity by Market Report'}
                actionsConfig={[
                  {
                    icon: <ArrowBackIcon size="small" className="back-button" />,
                    onClick: this.goBack,
                    title: 'Back to Report'
                  }
                ]}
              >
                Employee Allocation Activity by Market Report
            </PageHeader>
              <Grid container spacing={3} className='no-print row bottom-xs' style={{ marginLeft: '10px' }} >
                <Grid item xs={12} lg={2}>
                  <Grid item xs={12}>
                    <Autocomplete
                      multiple
                      blurOnSelect
                      limitTags={1}
                      value={this.state.market}
                      onChange={(e, val) => this.handleChange(e, val, 'market', 'marketName')}
                      id="tags-standard"
                      options={removeDuplicates(marketMasterData, 'marketName')}
                      getOptionLabel={(option) => option.marketName}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          label="Market"
                        // placeholder="Market"
                        />
                      )}
                    />
                  </Grid>
                </Grid>

                <Grid item xs={12} lg={2}>
                  <Grid item xs={12}>
                    <Autocomplete
                      multiple
                      blurOnSelect
                      limitTags={1}
                      value={this.state.department}
                      onChange={(e, val) => this.handleChange(e, val, 'department', 'departmentName')}
                      id="tags-standard"
                      options={removeDuplicates(departmentMasterData, 'departmentName')}
                      getOptionLabel={(option) => option.departmentName}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          label="Department"
                        />
                      )}
                    />

                  </Grid>
                </Grid>
                <Grid item xs={12} lg={2}>
                  <Grid item xs={12}>
                    <Autocomplete
                      multiple
                      blurOnSelect
                      limitTags={1}
                      value={this.state.division}
                      onChange={(e, val) => this.handleChange(e, val, 'division', 'division')}
                      id="tags-standard"
                      options={removeDuplicates(divisionMasterData, 'division')}
                      getOptionLabel={(option) => option.division}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          label="Division"
                        />
                      )}
                    />
                  </Grid>
                </Grid>
                <Grid item xs={12} lg={2}>
                  <Grid item xs={12}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <Grid container justify="space-around">
                        <KeyboardDatePicker
                          margin="normal"
                          id="date-picker-dialog"
                          label="Start Date"
                          format="MM/dd/yyyy"
                          name="startDate"
                          // maxDate={maxEndDate} // {endDate}
                          value={startDate}
                          onChange={(e) => this.handleDateChange(e, 'startDate')}
                          KeyboardButtonProps={{
                            'aria-label': 'change date'
                          }}
                          className="w-100"
                          shouldDisableDate={this.disableDatesForPayCycleStart}
                        />
                      </Grid>
                    </MuiPickersUtilsProvider>
                  </Grid>
                </Grid>
                <Grid item xs={12} lg={2}>
                  <Grid item xs={12}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <Grid container justify="space-around">
                        <KeyboardDatePicker
                          margin="normal"
                          id="date-picker-dialog"
                          label="End Date"
                          format="MM/dd/yyyy"
                          name="endDate"
                          minDate={startDate}
                          value={endDate}
                          onChange={(e) => this.handleDateChange(e, 'endDate')}
                          KeyboardButtonProps={{
                            'aria-label': 'change date'
                          }}
                          className="w-100"
                          shouldDisableDate={this.disableDatesForPayCycleEnd}
                        // maxDate={getCurrentPayCycleEndDateByDate(moment().format('MM/DD/YYYY'))}
                        />
                      </Grid>
                    </MuiPickersUtilsProvider>
                  </Grid>
                </Grid>

                <AdvancedFilter
                  filterConfig={advanceFilterConfig}
                  onApplyFilter={this.onAddvanceFilterChange}
                  openSlidingPanel={openSlidingPanel}
                  handleClose={this.handleClose}
                />
                <ReportButtons
                  resetPage={this.resetPage}
                  handleSubmit={this.handleSubmit}
                  handleClickOpen={this.handleClickOpen}
                  handlePrintClick={this.handlePrintClick}
                  downloadFile={this.downloadFile}
                  data={employeeData}
                />
                <Grid item xs={12} lg={2}>
                  <Grid item xs={12}>
                    <Autocomplete
                      multiple
                      blurOnSelect
                      limitTags={1}
                      id="tags-standard"
                      value={this.state.employee}
                      options={removeDuplicates(employeeMasterData, 'employeeName')}
                      getOptionLabel={(option) => option.employeeName}
                      onChange={(e, val) => this.handleChange(e, val, 'employee', 'employeeName')}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          label="Employee"
                        // placeholder="Employee Name"
                        />
                      )}
                    />
                  </Grid>
                </Grid>
                <Grid item xs={12} lg={2}>
                  <Grid item xs={12}>
                    <Autocomplete
                      multiple
                      limitTags={1}
                      blurOnSelect
                      id="tags-standard"
                      value={this.state.SupervisorEmployee || ''}
                      getOptionLabel={(option) => option.employeeName}
                      onChange={(e, val) => {
                        this.handleChange(e, val, 'SupervisorEmployee', 'employeeName');
                      }
                      }
                      options={removeDuplicates(supervisorEmployeeMasterData, 'employeeName')}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          label="Supervisor Name"
                        // placeholder="Employee Name"
                        />
                      )}
                    />
                  </Grid>
                </Grid>
              </Grid>
              {/* If Auto Run is not enabled and buttons not clicked, then show message to click button */}
              {(this.state.isAutoRunEnabled === false && this.state.isSubmitButtonClicked === false) && 
                (employeeData === null || employeeData.length <= 0) && (
                  <PageLandingMessage/>
                )
              }
              {/* If no data is found then show the message */}
              {showReport && (employeeData == null || employeeData.length <= 0) && (
                <Grid container spacing={4}>
                  <Grid
                    container
                    direction="row-reverse"
                    justify="center"
                    alignItems="stretch"
                  >
                    <label className="item-big">No Data Available.</label>
                  </Grid>
                </Grid>
              )}
              {/* If data is found then display the data into table format*/}
              {showReport && (
                <div>
                  {employeeData !== null && (
                    <div className="container" style={{ marginTop: '1rem' }}>
                      <TableContainer component={Paper}>
                        {this.renderTable(employeeData)}
                      </TableContainer>
                    </div>
                  )}
                </div>
              )}
            </>
          )}
      </div>
    );
  }
}
